<template>
  <div class="consult-container">
    <div class="consult-content">
      <div class="consult-header">
        <h2 class="consult-title">科技类项目咨询<span style="color: #F66F00;">•</span></h2>
        <p class="consult-subtitle">PROJECT CONSULTATION</p>
      </div>
      
      <div class="consult-form">
        <!-- 类别选择 -->
        <div class="form-group">
          <label class="form-label"><span class="required">*</span> 选择类别</label>
          <div class="category-options">
            <label class="category-item">
              <input type="radio" v-model="selectedCategories" value="科技成果评价">
              <span>科技成果评价</span>
            </label>
            <label class="category-item">
              <input type="radio" v-model="selectedCategories" value="科技成果登记">
              <span>科技成果登记</span>
            </label>
            <label class="category-item">
              <input type="radio" v-model="selectedCategories" value="科技查新">
              <span>科技查新</span>
            </label>
            <label class="category-item">
              <input type="radio" v-model="selectedCategories" value="科技奖励">
              <span>科技奖励</span>
            </label>
          </div>
        </div>
        
        <!-- 联系信息 -->
        <div class="form-row">
          <div class="form-group">
            <label class="form-label"><span class="required">*</span> 联系人(先生/女士)</label>
            <input type="text" v-model="contactName" class="form-input" placeholder="请输入联系人姓名">
          </div>
          <div class="form-group">
            <label class="form-label"><span class="required">*</span> 联系电话</label>
            <input type="tel" v-model="contactPhone" class="form-input" placeholder="请输入联系电话">
          </div>
          <div class="form-group">
            <label class="form-label">电子邮箱</label>
            <input type="email" v-model="contactEmail" class="form-input" placeholder="请输入电子邮箱">
          </div>
        </div>
        
        <!-- 提交按钮 -->
        <div class="form-actions">
          <button class="submit-btn" @click="submitForm">提交</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { submitConsult } from '@/api/index'

export default {
  data() {
    return {
      selectedCategories: '科技成果评价',//咨询类型: 科技成果评价-科技成果评价,科技成果登记-科技成果登记,科技查新-科技查新,科技奖励-科技奖励  
      contactName: '',
      contactPhone: '',
      contactEmail: ''
    }
  },
  methods: {
    submitForm() {
      // 表单验证
      if (!this.contactName) {
        alert('请输入联系人姓名');
        return;
      }
      if (!this.contactPhone) {
        alert('请输入联系电话');
        return;
      }
      // if (!this.contactEmail) {
      //   alert('请输入电子邮箱');
      //   return;
      // }
      if (this.selectedCategories.length === 0) {
        alert('请选择咨询类别');
        return;
      }
      submitConsult({
        type: this.selectedCategories,
        contact: this.contactName,
        phone: this.contactPhone,
        email: this.contactEmail
      }).then(res => {
        if (res.code === 1) {
          alert('提交成功！我们会尽快与您联系。');
          // 重置表单
          // this.selectedCategories = [];
          this.contactName = '';
          this.contactPhone = '';
          this.contactEmail = '';
        }
      })
    }
  }
}
</script>

<style scoped>
.consult-container {
  background: #fff;
  padding: 120px 0;
  width: 100%;
}

.consult-content {
  max-width: 1440px;
  margin: 0 auto;
  padding: 0 20px;
  width: 100%;
}

.consult-header {
  text-align: center;
  margin-bottom: 40px;
}

.consult-title {
  font-size: 30px;
  color: #1B5AFF;
  margin-bottom: 0;
  font-weight: bold;
  line-height: 30px;
}

.consult-subtitle {
  font-size: 24px;
  color: #DDE4EA;
  margin: 0;
}

.consult-form {
  width: 100%;
}

.form-group {
  margin-bottom: 60px;
}
.required{
  color: #F66F00;
}

.form-label {
  display: block;
  font-size: 18px;
  color: #333;
  margin-bottom: 8px;
}

.category-options {
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
}

.category-item {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 18px;
  color: #333;
  cursor: pointer;
}

.form-row {
  display: flex;
  gap: 24px;
  margin-bottom: 100px;
}

.form-row .form-group {
  flex: 1;
  margin-bottom: 0;
}

.form-input {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  outline: none;
  transition: border-color 0.3s;
}

.form-input:focus {
  border-color: #0066cc;
}

.form-actions {
  margin-top: 32px;
}

.submit-btn {
  display: block;
  width: 100%;
  padding: 12px 0;
  background-color: #111B5B;
  border: none;
  border-radius: 4px;
  font-weight: 500;
  font-size: 18px;
  color: #FFFFFF;
  cursor: pointer;
  transition: background-color 0.3s;
}

.submit-btn:hover {
  background-color: #1B5AFF;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .form-row {
    flex-direction: column;
    gap: 16px;
  }
  
  .category-options {
    flex-direction: column;
    gap: 12px;
  }
  
  .consult-header {
    margin-bottom: 24px;
  }
  
  .consult-title {
    font-size: 20px;
  }
  
  .form-actions {
    margin-top: 24px;
  }
}
</style>